import {
  RichEdit,
  RichEditClientCommand,
} from '@lmt/unicorn-shared/app/common/devexpress/RichEdit/dx-richedit';
import { useEventCallback } from '@mui/material';
import { ClientRichEdit } from 'devexpress-richedit/lib/client/client-rich-edit';
import i18next from 'i18next';
import { useEffect } from 'react';
import { useModal } from '../../common/ui-kit/modal/useModal';
import { defaultDocumentName } from './richedit-helper';

interface Props {
  richEdit: React.MutableRefObject<RichEdit>;
  resetCurrentDocument: () => void;
}

export const CreateNewDocument: React.FC<Props> = (props) => {
  const { richEdit, resetCurrentDocument } = props;
  const modals = useModal();

  const confirmUnsavedChanges = useEventCallback(async () => {
    const isConfirmed = await modals.showConfirm({
      title: i18next.t('documents.unsaved_changes_confirmation.title'),
      text: i18next.t(
        'documents.unsaved_changes_confirmation.text_new_template',
      ),
      okButtonText: i18next.t('documents.unsaved_changes_confirmation.ok_text'),
      cancelButtonText: i18next.t(
        'documents.unsaved_changes_confirmation.cancel_text',
      ),
    });
    return isConfirmed;
  });

  useEffect(function CreateNewDocumentHandler() {
    const richEditCurrent = richEdit?.current;
    const native = (richEditCurrent as any)._native as ClientRichEdit;
    const newDocumentCommand = native.core.commandManager.getCommand(
      RichEditClientCommand.CreateNewDocumentLocally,
    );
    const oldExecute = newDocumentCommand.execute;
    newDocumentCommand.execute = function (a, b) {
      const reset = () => {
        resetCurrentDocument();
        richEditCurrent.fileName = defaultDocumentName;
        return oldExecute.call(this, a, b);
      };
      if (richEditCurrent.hasUnsavedChanges) {
        confirmUnsavedChanges()
          .then((isConfirmed) => {
            if (isConfirmed) {
              return reset();
            }
          })
          .catch((e) => {
            console.error(e);
          });
        return false;
      } else {
        return reset();
      }
    };
    return () => {
      newDocumentCommand.execute = oldExecute;
    };
  }, []);

  return null;
};
